import { render, staticRenderFns } from "./BSButtonSort.vue?vue&type=template&id=6a54359d&"
import script from "./BSButtonSort.vue?vue&type=script&lang=js&"
export * from "./BSButtonSort.vue?vue&type=script&lang=js&"
import style0 from "./BSButtonSort.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports